/**
 * Shared type → (icon, color) mapping for notifications, used by both
 * `NotificationBell.tsx` (header dropdown) and `src/pages/Announcements.tsx` (archive),
 * so the two surfaces can never show a different icon or color for the same type.
 *
 * Shape (icon) + color together, never color alone — a colorblind visitor still
 * gets a distinct glyph per type, and the visible title text next to it is never
 * color-only information either.
 */

import { AlertTriangle, Newspaper, Sparkles, Wrench, Zap, type LucideIcon } from 'lucide-react'
import type { NotificationType } from '@/lib/notifications'

export const NOTIFICATION_VISUALS: Record<NotificationType, { icon: LucideIcon; className: string }> = {
  maintenance: { icon: Wrench, className: 'text-warning' },
  important: { icon: AlertTriangle, className: 'text-error' },
  update: { icon: Sparkles, className: 'text-info' },
  feature: { icon: Zap, className: 'text-info' },
  news: { icon: Newspaper, className: 'text-base-content/60' },
}
